module.exports = __webpack_public_path__ + "static/img/62.dcc5761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/62.png
// module id = ULxH
// module chunks = 0